import { differenceInMinutes } from "date-fns"

export function getTimeUntilMidnightUTC(): string {
  const now = new Date()

  const utcYear = now.getUTCFullYear()
  const utcMonth = now.getUTCMonth()
  const utcDate = now.getUTCDate()

  const target = new Date(Date.UTC(utcYear, utcMonth, utcDate + 1, 0, 0, 0))

  const minutes = differenceInMinutes(target, now)
  const hours = Math.floor(minutes / 60)
  const remainingMinutes = minutes % 60

  return `${hours}h ${remainingMinutes}m`
}
